<template>
  <div style="position: relative">
    <div class="search flex">
      <span class="tit">角色管理</span>
      <div class="flex">
        <el-button class="addBtn" @click="addRole" size="small">新增角色</el-button>
        <el-input class="addART"
                  placeholder="角色名称、角色代码"
                  v-model="page.name"
                  @change="skipPage(1)"
                  suffix-icon="el-icon-search">
        </el-input>

      </div>
    </div>
    <el-table :data="page.rows" class="record-table"
              :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
              height="calc(100vh - 300px)"
              max-height="calc(100vh - 300px)">
      <el-table-column prop="roleCode" label="代码" align="center" show-overflow-tooltip>
        <span slot-scope="scope">{{ scope.row.roleCode.replace("role_", "") }}</span>
      </el-table-column>
      <el-table-column prop="roleName" label="名称" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="roleType" label="类型" align="center" width="100">
        <template slot-scope="scope">{{ scope.row.roleType == 0 ? '系统' : '用户' }}</template>
      </el-table-column>
      <el-table-column label="权限" align="center" width="80">
        <template slot-scope="scope">
          <el-popover :title=scope.row.roleName
                      width="400"
                      trigger="hover"
                      placement="right">
            <el-table :data="scope.row.permissions" class="record-table"
                      max-height="400px"
                      :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}">
              <el-table-column prop="name" label="权限名称" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="permission" label="权限代码" align="center" show-overflow-tooltip></el-table-column>
            </el-table>
            <i slot="reference" class="el-icon-question role-icon"></i>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="scope">
          <span class="warning-tips-text" v-if="scope.row.roleType==0">系统角色无法修改</span>
          <el-button @click="editRole(scope.row)" v-if="scope.row.roleType!=0" type="text" class="btn"
                     size="small">权限
          </el-button>
          <el-button @click="editRoleInfo(scope.row)" v-if="scope.row.roleType!=0" type="text" class="btn"
                     size="small">修改
          </el-button>
          <el-button @click="delRole(scope.row.id)" v-if="scope.row.roleType!=0" type="text" class="btn"
                     size="small">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        style="margin-top: 8px;"
        class="pagination"
        :hide-on-single-page="true"
        background
        prev-text="Prev"
        next-text="Next"
        @current-change="skipPage"
        :current-page="page.current"
        :page-size="page.size"
        layout="total, prev, pager, next"
        :total="page.total">
    </el-pagination>

    <!-- 修改权限 -->
    <el-drawer :visible.sync="editRoleDialog.show" :wrapperClosable="false" :show-close="false"
               @opened="echoRolePermission" title="选择角色权限" size="700px" class="drawerCommon">
      <el-table ref="multiplePermissionTable"
                :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
                height="calc(100vh - 180px)" class="record-table"
                max-height="calc(100vh - 180px)" :data="allPermissions">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column prop="name" label="权限名" align="center"></el-table-column>
        <el-table-column prop="roleCode" label="权限代码" align="center">
          <span slot-scope="scope">{{ scope.row.permission }}</span>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-button style="width: 90px;" size="small" type="primary" @click="saveRolePermission"
                   :loading="editRoleDialog.load">保存
        </el-button>
        <el-button style="width: 90px;margin-left: 20px" size="small" @click="editRoleDialog.show=false">取消</el-button>
      </div>
    </el-drawer>

    <!-- 修改基本信息 -->
    <el-drawer :visible.sync="editRoleInfoDialog.show"  :wrapperClosable="false"
               :show-close="false"  size="600px" class="drawerCommon"
               :title="editRoleInfoDialog.title" >
      <el-form v-model="editRoleInfoDialog.form"  label-suffix="：" label-width="90px" class="maxHeight">
        <el-form-item label="角色代码"  >
          <el-input v-model="editRoleInfoDialog.form.roleCode" :disabled="editRoleInfoDialog.mode=='edit'"
                    placeholder="长度4-20以字母开头;只能包含数字、字母、下划线"></el-input>
        </el-form-item>
        <el-form-item label="角色名称">
          <el-input v-model="editRoleInfoDialog.form.roleName"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" :rows="5" v-model="editRoleInfoDialog.form.remark"></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button style="width: 90px;" size="small" type="primary" @click="saveRoleInfo" :loading="editRoleInfoDialog.load">
          {{ editRoleInfoDialog.mode === 'add' ? '新增' : '更新' }}
        </el-button>
        <el-button style="width: 90px;margin-left: 20px" size="small" @click="editRoleInfoDialog.show=false">取消</el-button>
      </div>
    </el-drawer>


  </div>
</template>

<script>
import base from '@/api/common';

export default {
  name: "roleManage.vue",
  data() {
    return {
      page: {
        current: 1,
        size: 10,
        total: 9,
        rows: [],

        name: ''
      },
      allPermissions: [],

      /* 编辑权限dialog */
      editRoleDialog: {
        show: false,
        load: false,
        form: {
          id: '',
          permissions: [],
        },
      },

      /* 编辑角色信息dialog */
      editRoleInfoDialog: {
        title: '',
        mode: '',
        show: false,
        load: false,
        form: {
          id: '',
          roleCode: '',
          roleName: '',
          remark: ''
        }
      }
    }
  },
  mounted() {
    this.skipPage(1);

    // 加载所有权限
    this.$ajax.get(base.manager_api.auth.all_permissions).then(res => {
      if (res.data.status === 'success') {
        this.allPermissions = res.data.list;
      }
    });
  },
  methods: {
    removeItemById(id) {
      let index = -1;
      $(this.page.rows).each((i, o) => {
        if (o.id == id) {
          index = i;
        }
      });
      if (index > -1) {
        this.page.rows.splice(index, 1);
      }
    },
    skipPage(cur) {
      this.page.current = cur;
      this.$ajax.get(base.manager_api.auth.role.page, {
        params: {
          page: this.page.current,
          size: this.page.size,
          name: this.page.name
        }
      }).then(res => {
        if (res.data.status === 'success') {
          this.page.current = res.data.current;
          this.page.size = res.data.size;
          this.page.total = res.data.total;
          this.page.rows = res.data.rows;
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.$message.error('信息加载失败');
        console.error(err);
      });
    },
    /* 编辑权限部分 */
    editRole(item) {
      this.editRoleDialog.show = true;
      this.editRoleDialog.form.id = item.id;
      this.editRoleDialog.form.permissions = item.permissions;
    },
    echoRolePermission() {
      let roleId = this.editRoleDialog.form.id;
      if (roleId) {
        let permissions = this.editRoleDialog.form.permissions;
        this.$refs.multiplePermissionTable.clearSelection();
        if (permissions.length != 0) {
          $(this.allPermissions).each((i, o) => {
            $(permissions).each((ei, eo) => {
              if (o.id == eo.id) {
                this.$refs.multiplePermissionTable.toggleRowSelection(o);
                return false; // 提前结束内循环
              }
            });
          });
        }
      }
    },
    saveRolePermission() {
      let roleId = this.editRoleDialog.form.id;
      let permissions = this.$refs.multiplePermissionTable.selection;
      let reqData = [];
      $(permissions).each((i, o) => {
        reqData.push({
          permissionId: o.id
        })
      });
      this.editRoleDialog.load = true;
      this.$ajax.post(base.manager_api.auth.role.update_permission.replace("{id}", roleId), reqData).then(res => {
        this.editRoleDialog.load = false;
        if (res.data.status === 'success') {
          this.$message.success('操作成功');
          this.editRoleDialog.show = false;
          this.skipPage(this.page.current); // 重新查询当前页内容
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.editRoleDialog.load = false;
        this.$message.error("操作失败");
        console.error(err);
      });
    },
    /* 新增/修改role基本信息 */
    addRole() {
      this.editRoleInfoDialog.title = '新增角色';
      this.editRoleInfoDialog.mode = 'add';
      this.editRoleInfoDialog.form.id = '';
      this.editRoleInfoDialog.form.roleCode = '';
      this.editRoleInfoDialog.form.roleName = '';
      this.editRoleInfoDialog.form.remark = '';
      this.editRoleInfoDialog.show = true;
    },
    editRoleInfo(item) {
      this.editRoleInfoDialog.title = '编辑角色';
      this.editRoleInfoDialog.mode = 'edit';
      this.editRoleInfoDialog.form.id = item.id;
      this.editRoleInfoDialog.form.roleCode = item.roleCode.replace('role_', '');
      this.editRoleInfoDialog.form.roleName = item.roleName;
      this.editRoleInfoDialog.form.remark = item.remark;
      this.editRoleInfoDialog.show = true;
    },
    saveRoleInfo() {
      let code = this.editRoleInfoDialog.form.roleCode;
      let name = this.editRoleInfoDialog.form.roleName;
      let remark = this.editRoleInfoDialog.form.remark;

      if ($.trim(code).length === 0) {
        this.$message.warning('角色代码不能为空!');
        return;
      }
      if (!base.reg.code.test(code)) {
        this.$message.warning('角色代码不合法');
        return;
      }
      if ($.trim(name).length === 0) {
        this.$message.warning('角色名称不能为空!');
        return;
      }

      let model = this.editRoleInfoDialog.mode;
      let roleId = this.editRoleInfoDialog.form.id;
      let url;

      if (model === 'add') {
        url = base.manager_api.auth.role.add;
      } else if (model === 'edit') {
        if (!roleId) {
          return;
        }
        url = base.manager_api.auth.role.update.replace("{id}", roleId);
      } else {
        return;
      }

      this.editRoleInfoDialog.load = true;
      this.$ajax.post(url, {
        roleCode: code,
        roleName: name,
        remark: remark
      }).then(res => {
        this.editRoleInfoDialog.load = false;
        if (res.data.status === 'success') {
          this.$message.success("操作成功");
          this.editRoleInfoDialog.show = false;
          this.skipPage(this.page.current); // 重新查询当前页内容
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.$message.error("操作失败");
        this.editRoleInfoDialog.load = false;
      })


    },
    /* 删除权限部分 */
    delRole(id) {
      this.$messageBox.confirm('确定要删除此角色吗?', '删除确认', {type: 'warning'}).then(_ => {
        this.$ajax.post(base.manager_api.auth.role.del.replace("{id}", id)).then(res => {
          if (res.data.status === 'success') {
            this.$message.success('操作成功');
            this.removeItemById(id);

          } else {
            this.$message.error(res.data.message);
          }
        }).catch(err => {
          this.$message.error("操作失败");
          console.err(err);
        })

      });
    },
    /* 编辑基本资料信息 */


  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/admin.scss';

button.btn {
  padding: 0
}

i.role-icon {
  font-size: 18px;
  cursor: pointer
}

.warning-tips-text {
  color: #E6A23C;
  font-size: 12px;
}

</style>
<style lang="css">
.el-dialog__body {
  max-height: 500px;
  overflow: auto;
}
</style>